import angular from 'angular';
import MODULE_NAME from '../../app'
import dataHolderFactory from './dataHolderFactory'
import googleMapsInitializerFactory from './googleMapsInitializerFactory'
import heatMapOverlayFactory from './heatMapOverlayFactory'
import objectMakerFactory from './objectMakerFactory'
import onControllerLabelsForLanguageFactory from './onControllerLabelsForLanguageFactory'
import onViewLabelsForLanguageFactory from './onViewLabelsForLanguageFactory'
import parameterFactory from './parameterFactory'
import urlFactory from './urlFactory'

angular.module(MODULE_NAME)
.factory('dataHolderFactory', dataHolderFactory)
.factory('googleMapsInitializerFactory', googleMapsInitializerFactory)
.factory('heatMapOverlayFactory', heatMapOverlayFactory)
.factory('objectMakerFactory', objectMakerFactory)
.factory('onControllerLabelsForLanguageFactory', onControllerLabelsForLanguageFactory)
.factory('onViewLabelsForLanguageFactory', onViewLabelsForLanguageFactory)
.factory('parameterFactory', parameterFactory)
.factory('urlFactory', urlFactory)



// WEBPACK FOOTER //
// ./src/app/scripts/factories/index.js